import LoginService from '@/services/LoginService';

export default {
  namespaced: true,
  state: { token: null },
  mutations: {
    m_token(state: any, token: any) {
      state.token = token;
    },
  },
  actions: {
    async a_post_login({ commit }: any, { login, password }: any) {
      console.log('Store', { login, password });
      await LoginService.login({ login, password }).then((res: any) => {
        if (res.status === 200) {
          console.log(res.data);
          const token = res.data.accessToken;
          commit('m_token', token);
          if (window.localStorage) {
            window.localStorage.setItem('token', token);
          }
        }
      });
    },
    async a_init_token({ commit }: any, { token }: any) {
      commit('m_token', token);
    },
    async a_reset_token({ commit }: any) {
      commit('m_token', null);
      if (window.localStorage) {
        window.localStorage.setItem('token', '');
      }
    },
    async a_post_changePassword({ commit }: any, { login, oldPassword, newPassword }: any) {
      await LoginService.changePassword({ login, oldPassword, newPassword }).then((res: any) => {
        if (res.status === 200) {
          console.log(res.data);
        }
      });
    },
  },
  getters: {
    token: (state: any) => state.token,
  },
};
